import type { SVGProps } from "react";
export interface TranslateIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TranslateIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TranslateIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.238 8.013a2.13 2.13 0 0 1 1.523 0l.24.11.188.119c.411.298.637.745.776 1.05.183.4.377.94.6 1.567l3.495 9.762.032.11a1.125 1.125 0 0 1-2.107.754l-.044-.107-.807-2.253h-6.268l-.807 2.253-.044.107a1.126 1.126 0 0 1-2.074-.864l3.494-9.762c.224-.626.416-1.167.599-1.567.16-.349.432-.884.965-1.169zm.618 2.769-.303.836-1.883 5.257h4.66l-1.882-5.257A29 29 0 0 0 17 10.426q-.066.154-.144.356M6.875 3a1.125 1.125 0 0 1 2.25 0v.875H14l.116.005a1.126 1.126 0 0 1 0 2.239L14 6.125h-1.572c-.52 2.434-1.44 4.63-2.71 6.55.364.272.715.51 1.046.693l.239.126.101.056a1.126 1.126 0 0 1-1.002 2.002l-.105-.045-.318-.169c-.439-.243-.88-.54-1.317-.868-1.613 1.878-3.595 3.404-5.86 4.536a1.125 1.125 0 0 1-1.004-2.012c2.01-1.006 3.752-2.352 5.162-3.996-.926-.914-1.778-1.947-2.369-2.95L3.992 9.5l-.045-.105a1.126 1.126 0 0 1 2.004-.998l.057.101.23.422c.425.717 1.05 1.508 1.772 2.25a16.7 16.7 0 0 0 2.113-5.046H2a1.125 1.125 0 0 1 0-2.25h4.875z"
      />
    </svg>
  );
}
